<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" destroy-on-close>
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="挑战赛名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入挑战赛名称" />
      </a-form-model-item>
      <a-form-model-item label="挑战赛类型" prop="challengeType">
        <a-select v-model="form.challengeType" placeholder="请选择挑战赛类型">
          <a-select-option v-for="item in typeList" :value="item.id" :key=item.id>{{item.typeName}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="挑战赛logo" prop="logo" >
        <file-upload type="image" :defaultList="form.logoArr" :count="1" :imgSize="'310*200'"
                     @input="getImg($event, 'logo')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="广告图" prop="advertisementPhoto" >
        <file-upload type="image" :defaultList="form.advertisementPhotoArr" :count="6"
                     @input="getImg($event, 'advertisementPhoto')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-radio-group v-model="form.status">
          <a-radio :value="0">未开始</a-radio>
          <a-radio :value="1">进行中</a-radio>
          <a-radio :value="2">已结束</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="开始时间" prop="startTime" >
        <a-date-picker style="width: 100%" v-model="form.startTime" format="YYYY-MM-DD" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="截止时间" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="活动说明" prop="activityDescription" >
        <editor type="textarea" v-model="form.activityDescription"/>
      </a-form-model-item>
      <a-form-model-item label="中奖说明" prop="winningDescription" >
        <a-input :maxLength="300" type="textarea" v-model="form.winningDescription"   />
      </a-form-model-item>
      <a-form-model-item label="累计积分" prop="needScore" >
        <a-input-number style="width: 200px" :min="0" v-model="form.needScore" placeholder="请输入累计积分数"/>
      </a-form-model-item>
      <a-form-model-item label="累计现金券" prop="needVoucher" >
        <a-input-number style="width: 200px"  :min="0" v-model="form.needVoucher" placeholder="请输入累计现金券数"/>
      </a-form-model-item>
      <a-form-model-item label="积分+现金券" prop="scoreVoucher" >
        <a-input-number style="width: 200px"  :min="0" v-model="form.scoreVoucher" placeholder="请输入积分+现金券数" />
      </a-form-model-item>
      <a-form-model-item label="参与条件" prop="joinCondition">
        <a-input :maxLength="300" type="textarea" v-model="form.joinCondition"   />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getChallenge, addChallenge, updateChallenge } from '@/api/challenge/challenge'
import {guid} from "@/utils/ruoyi";
import Editor  from '@/components/Editor'
import {listType} from "@/api/challenge/type";
import TagSelectOption from "@/components/TagSelect/TagSelectOption";
import moment, { locale } from "moment";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    TagSelectOption,
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      typeList:[],
      // 表单参数
      form: {
        id: null,

        name: null,

        logo: null,
        logoArr:[],
        logoCount:1,
        advertisementPhoto:null,
        advertisementPhotoArr:[],
        advertisementPhotoCount:1,
        challengeType:null,
        startTime: null,
        joinCondition:null,
        endTime: null,

        activityDescription: null,

        winningDescription: null,

        needScore: null,

        needVoucher: null,

        scoreVoucher: null,

        peopleNum: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        challengeType: [
          { required: true, message: '挑战赛类型不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '挑战赛名称不能为空', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '挑战赛logo不能为空', trigger: 'blur' }
        ],
        // advertisementPhoto: [
        //   { required: true, message: '广告图不能为空', trigger: 'blur' }
        // ],
        activityDescription: [
          { required: true, message: '活动说明不能为空', trigger: 'blur' }
        ],
        winningDescription: [
          { required: true, message: '中奖说明不能为空', trigger: 'blur' }
        ],
        joinCondition: [
          { required: true, message: '参与条件不能为空', trigger: 'blur' }
        ],
        ruleConfig: [
          { required: true, message: '规则配置json格式不能为空', trigger: 'blur' }
        ],
        peopleNum: [
          { required: true, message: '参与人数不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initType()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    initType(){
      listType({isDeleted:0}).then(res=>{
        this.typeList = res.data
      })
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        challengeType:null,
        logo: null,
        logoArr:[],
        logoCount:1,
        joinCondition:null,
        startTime: null,
        endTime: null,
        activityDescription: null,
        winningDescription: null,
        needScore: null,
        needVoucher: null,
        scoreVoucher: null,
        peopleNum: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.open = true
      this.formType = 2
      const id = row ? row.id : ids
      getChallenge({"id":id}).then(response => {
        this.form = response.data
        this.formTitle = '修改'
        let that = this;
        this.form.logoArr = []
        this.form.advertisementPhotoArr = []
        this.form.logoArr.push({
          uid: guid(8, 10),
          name: that.form.logo,
          status: 'done',
          halfUrl: that.form.logo,
          url: that.form.logo,
          path: that.form.logo
        })
        this.form.advertisementPhoto.split(',').forEach(item=>{
          that.form.advertisementPhotoArr.push({
            uid: guid(8, 10),
            name: item,
            status: 'done',
            halfUrl: item,
            url: item,
            path: item
          })
        })
    })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(new Date(this.form.startTime)>new Date(this.form.endTime)){
            this.$message.error("开始时间不能大于结束时间")
            return
          }
          this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
          this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateChallenge(this.form).then(res => {
              if(res.success){
                this.$message.success(
                  '修改成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addChallenge(this.form).then(res => {
              if(res.success){
                this.$message.success(
                  '新增成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
